import {throttle} from "../utils";

const Header = () => {
    const elements = {
        self: null,
        links: null,
    }

    const classes = {
        self: '.header',
        menuAction: '.header-nav__action',
        collapses: '.header .collapsable',
        links: '[data-header-link]'
    }

    const modifiers = {
        thin: 'header_thin',
        open: 'header_open',
    }

    const init = () => {
        queryElements();
        registerEvents();
        toggleMobileMenu();
        menuCollapses();
        // handleLinks();
    }

    const queryElements = () => {
        elements.self = document.querySelector(classes.self);
    }

    const registerEvents = () => {
        window.addEventListener('scroll', throttle(scrollEvent, 10));
    }

    const scrollEvent = (e) => {
        if(window.scrollY >= 50) {
            elements.self.classList.add(modifiers.thin);
        } else {
            elements.self.classList.remove(modifiers.thin);
        }
    }
    
    const toggleMobileMenu = () => {
      elements.menuAction = document.querySelector(classes.menuAction);
      
      if (elements.menuAction) {
        elements.menuAction.addEventListener('click', () => {
          elements.self.classList.toggle(modifiers.open);
        })
      }
    }
    
    const menuCollapses = () => {
      elements.collapses = document.querySelectorAll(classes.collapses);
  
      const handleClick = (e) => {
        const parent = e.target.closest(".collapsable");
    
        if (parent.classList.contains("active")) {
          parent.classList.remove("active");
        } else {
          elements.collapses?.forEach((collapse) => collapse.classList.remove("active"));
          parent.classList.add("active");
        }
      };
  
      elements.collapses?.forEach((collapse) =>
        collapse.addEventListener("click", handleClick)
      );
    }
    
    const handleLinks = () => {
      elements.links = document.querySelectorAll(classes.links)
      
      if (!elements.links) return null
      
      const handleLinkClick = (e) => {
        const lang = document.documentElement.lang.slice(0, 2)
        const category = e.currentTarget.getAttribute('data-header-link')
        
        if (window?.dataLayer) {
          window.dataLayer.push({
            'page': {
              lang,
              category
            }
          })
  
          console.log(window?.dataLayer)
        }
      }
      
      ;[...elements.links].forEach(link => link.addEventListener('click', handleLinkClick))
    }

    return init();
}

export default Header;
